import TKeyType from '../../i18ns/admin/TKeyType'

const blacklistMemoOptions: TKeyType[] = [
  'common.maliciousLoss',
  'common.maliciousReport',
  'common.wrongBindingInfo',
  'common.riskControlZHCNText',
  'common.amountLimited',
  'common.otherMemo'
]

export default blacklistMemoOptions
